import type { ComponentProps } from "react"

export default function IndustryJ(
  props: ComponentProps<"svg"> & { fill?: string },
) {
  const { fill = "currentColor", ...svgProps } = props

  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M1.33333 0H30.6667C30.6667 0 32 0 32 1.33333V30.6667C32 30.6667 32 32 30.6667 32H1.33333C1.33333 32 0 32 0 30.6667V1.33333C0 1.33333 0 0 1.33333 0ZM14.6666 8.5H5.33325V7.5H14.6666V8.5ZM14.6666 16.5H5.33325V15.5H14.6666V16.5ZM26.6666 24.5H5.33325V23.5H26.6666V24.5ZM26.6666 6.6665H17.3333V17.3332H26.6666V6.6665Z"
        fill={fill}
      />
    </svg>
  )
}
